import type { ParameterTimeSeriesChartResult } from "@/lib/api";

export type ChartSeriesPresentationState = "available" | "noData";

type SeriesConfigLike = {
  label?: string;
  parameter_id: string;
};

type ChartTimeRange = {
  timeStart: Date;
  timeEnd: Date;
};

export function resolveSeriesDisplayLabel(
  seriesConfig: SeriesConfigLike,
  result: ParameterTimeSeriesChartResult | undefined,
): string {
  return seriesConfig.label ?? result?.parameter.label ?? seriesConfig.parameter_id;
}

export function getChartSeriesPresentationState(
  result: ParameterTimeSeriesChartResult | undefined,
  timeRange: ChartTimeRange,
): ChartSeriesPresentationState {
  if (!result || !result.data) return "noData";

  const hasDataInRange = result.data.datapoints.some(
    (datapoint) =>
      +new Date(datapoint.timestamp) > +timeRange.timeStart &&
      +new Date(datapoint.timestamp) < +timeRange.timeEnd,
  );

  return hasDataInRange ? "available" : "noData";
}

export function chartSeriesPresentationColor(
  state: ChartSeriesPresentationState,
  activeColor: string,
): string {
  return state === "available" ? activeColor : "grey";
}

export function formatChartSeriesName(
  displayLabel: string,
  state: ChartSeriesPresentationState,
  t: (key: string, options?: { parameter: string }) => string,
): string {
  if (state === "available") return displayLabel;
  return t("chart.series_not_available", { parameter: displayLabel });
}

export function chartSeriesIsDisabled(state: ChartSeriesPresentationState): boolean {
  return state !== "available";
}
